import angular from "angular";

angular
    .module('api-sentinel')
    .constant('SENTINEL_API_HOST_CONSTANTS', {
        'URL': 'https://eu-ors-api.onasset.com',
        'VISION_URL': 'https://tracking.eu.organ-recovery.com/track/',
        'AI_TRACKING_URL': 'https://oainsightai.onasset.com',
        // 'true' on QA/local builds, 'false' everywhere else. Overridable at runtime with
        // localStorage.setItem('webAuthLog', 'true') - see SentinelUiSession.authLog.
        'WEB_AUTH_LOG': 'false',
        'ERRORS': {
            'AUTHENTICATION_REQUIRED': 'AUTHENTICATION_REQUIRED'
        },
        'USER_ROLES': {
            none: 'api-none',
            all: 'api-all',
            apiAdmin: 'api-admin',
            apiAccount: 'api-account'
        }
    });
